import { Component } from "react";
import { connect } from "react-redux";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import {
  decrementQuantity,
  incrementQuantity,
  removeItemFromOrder,
  setChanges,
  setHideOrderModal,
  setShowOrderModal,
} from "../../redux-state/features/orderState";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faMinus,
  faPenAlt,
  faPlus,
  faTrashCan,
} from "@fortawesome/free-solid-svg-icons";
import ItemsSelect from "../itemsSelect";
import ItemsForm from "../itemsForm";
import axios from "axios";
import urls from "../../urls";
import { showError, showSuccess } from "../../utils/notifications";
import _ from "lodash";

class OrderForm extends Component {
  /**
   *
   */
  constructor() {
    super();
    this.state = {
      isLoading: false,
    };
    this.headerText = ["الرقم", "التعيين ", " المتاح", "المطلوب", "-"];
    // this.props.userType === "admin"
    //  ["الرقم", "التعيين ", " المتاح", "المطلوب", "-"]
    // : ["الرقم", "التعيين ", "المطلوب", "-"];
    this.widths = ["10%", "45%", "10%", "10%", "25%"];
  }
  handlePlaceNewOrder = () => {
    const { orderItems, uuid, faculty_id } = this.props;
    if (orderItems.length === 0) {
      showError("يجب إضافة على الأقل عنصر واحد الى طلبيتك");
      return;
    }

    axios
      .post(urls.placeNewOrder, {
        orderItems,
        uuid,
        faculty_id,
      })
      .then((res) => {
        if (res.status === 200) {
          showSuccess("تم إضافة طلبك سيتم معالجتة قريبا ");
          this.props.setHideOrderModal();
        }
      })
      .catch((err) => {
        showError("حدث خطأ أثناء إنشاء الطلب ");
        console.log(err);
      });
  };
  updateOrder = () => {
    const { orderItems } = this.props;
    const itemsUpdateData = _.map(orderItems, (obj) => {
      return {
        id: obj.ordered_item_id,
        quantity: obj.quantity,
      };
    });
    if (itemsUpdateData.length === 0) {
      showError("لا يمكن تحديث طلب فارغ ");
      return;
    }
    this.setState({ isLoading: true });
    axios
      .put(urls.updateOrder, itemsUpdateData)
      .then((res) => {
        this.setState({ isLoading: false });
        showSuccess("تم تحديث الطلب بنجاح");
        this.props.setChanges(false);
      })
      .catch((err) => {
        console.log(err);
        showError("لم يتم حفظ التغييرات بنجاح . حدث خطأ ");
      })
      .finally(() => {
        this.setState({ isLoading: false });
      });
    console.log("update order ", itemsUpdateData);
  };
  render() {
    const { show, orderItems, orderStatus, userType } = this.props;

    const headerText =
      userType === "admin"
        ? ["الرقم", "التعيين ", " المتاح", "المطلوب", "الموافق عليه", "-"]
        : ["الرقم", "التعيين ", "العدد", "-"];
    const widths =
      userType === "admin"
        ? ["10%", "35%", "10%", "10%", "10%", "25%"]
        : ["10%", "50%", "10%", "30%"];
    const modalTitle = userType === "admin" ? "تعديل الطلب" : "طلب مستلزمات ";
    return (
      <div>
        <Modal
          show={show}
          onHide={() => this.props.setHideOrderModal()}
          backdrop="static"
          keyboard={false}
          size="xl"
        >
          <Modal.Header closeButton>
            <Modal.Title style={{ fontSize: "14px" }}>{modalTitle}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {userType != "admin" && <ItemsForm />}
            <hr />
            <table className="table align-middle  text-center">
              <thead>
                <tr className="align-middle ">
                  {headerText.map((txt, idx) => (
                    <th
                      scope="col"
                      key={"order-table" + idx}
                      style={{ width: widths[idx] }}
                      className={idx === 2 ? "table-primary text-primary" : ""}
                    >
                      {txt}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {orderItems.map((obj, index) => (
                  <tr key={"order-tr-" + index}>
                    <td>{index + 1}</td>
                    <td>
                      {Object.keys(obj).includes("item_name")
                        ? obj.item_name
                        : obj.orderItem}
                    </td>
                    {userType === "admin" && (
                      <>
                        <td className="table-primary text-primary">
                          {" "}
                          {obj.available_quantity}
                        </td>
                        <td>{obj.requested_quantity}</td>
                      </>
                    )}

                    <td>{obj.quantity}</td>
                    <td>
                      <button
                        className="btn mx-2 border-0"
                        onClick={() => {
                          this.props.incrementQuantity({
                            orderId: obj.ordered_item_id,
                          });
                          this.props.setChanges(true);
                        }}
                      >
                        <FontAwesomeIcon icon={faPlus} size="lg" />
                      </button>
                      <button
                        className="btn mx-2 border-0"
                        onClick={() => {
                          this.props.decrementQuantity({
                            orderId: obj.ordered_item_id,
                          });
                          this.props.setChanges(true);
                        }}
                      >
                        <FontAwesomeIcon icon={faMinus} size="lg" />
                      </button>
                      <button
                        className="btn mx-2 border-0"
                        onClick={() => {
                          this.props.removeItemFromOrder(obj.orderId);
                        }}
                      >
                        <FontAwesomeIcon
                          className="mx-2"
                          icon={faTrashCan}
                          size="lg"
                        />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => this.props.setHideOrderModal()}
            >
              إلغاء
            </Button>
            {userType === "admin" ? (
              <Button
                variant="primary"
                onClick={this.updateOrder}
                disabled={!this.props.areChangesMade}
              >
                {this.state.isLoading ? (
                  <div
                    className="spinner-border text-white mx-2"
                    style={{ width: "1rem", height: "1rem" }}
                    role="status"
                  >
                    <span className="visually-hidden">Loading...</span>
                  </div>
                ) : (
                  " تحديث الطلب"
                )}
              </Button>
            ) : (
              <Button variant="primary" onClick={this.handlePlaceNewOrder}>
                إرسال الطلب{" "}
              </Button>
            )}
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

const mapDispatchToProps = {
  setHideOrderModal,
  removeItemFromOrder,
  incrementQuantity,
  decrementQuantity,
  setChanges,
};
const mapStateToProps = (state) => ({
  show: state.orderState.showOrderModal,
  orderItems: state.orderState.orderItems,
  orderStatus: state.orderState.Status,
  areChangesMade: state.orderState.areChangesMade,
  userType: state.userState.userType,
  uuid: state.userState.uuid,
  faculty_id: state.userState.faculty_id,
});
export default connect(mapStateToProps, mapDispatchToProps)(OrderForm);
